import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../actions/getSANAdPartnerZeitStatus';
import { INIT_STATE } from './TikTokSAN.constants';
import type { TikTokSANState } from './TikTokSAN.types';
import type { TikTokSANAction } from './actions';
import { GET_TIKTOK_SAN_ADVERTISERS, GET_TIKTOK_SAN_AUTHENTICATION_URL } from './actions';

function handler(state: WrappedReducer<TikTokSANState>, action: TikTokSANAction): WrappedReducer<TikTokSANState> {
  switch (action.type) {
    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_tiktok } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_tiktok,
        loading: false,
      };

    case GET_TIKTOK_SAN_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    case GET_TIKTOK_SAN_ADVERTISERS.request:
      return {
        ...state,
        loading: true,
      };
    case GET_TIKTOK_SAN_ADVERTISERS.response:
      const { advertisers } = action.data;
      return {
        ...state,
        advertisers: advertisers,
        loading: false,
      };

    default:
      return state;
  }
}

const TikTokSAN = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_TIKTOK_SAN_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_TIKTOK_SAN_ADVERTISERS],
  error: [GET_TIKTOK_SAN_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_TIKTOK_SAN_ADVERTISERS],
  resetOn: ['APP_CHANGE'],
});

export default TikTokSAN;
